/** Values stored in offers.target_page and mapped to Credco client routes (`prices` and `products` both resolve to /products). */
export const OFFER_LINK_CHOICES = [
    { id: 'prices', name: 'Prices' },
    { id: 'watchlist', name: 'Watchlist' },
    { id: 'news-feed', name: 'News' },
    { id: 'directory', name: 'Directory' },
    { id: 'orders', name: 'Orders' },
    { id: 'profile', name: 'Profile' },
    { id: 'reprocessed', name: 'Reprocessed' },
    { id: 'external', name: 'External URL' },
] as const;
